<template>
    <div>
        <div v-html="message"/>
        <br/>

        <form-row :label="clientTerm + ' per E-Mail informieren'" label-for="send-mail" class="form-row-checkbox label-auto-width element-first no-margin" hide-validator-icon>
            <form-input-checkbox v-model="sendMail"/>
        </form-row>
    </div>
</template>

<script setup lang="ts">
    import FormInputCheckbox from '@/components/form/FormInputCheckbox.vue';
    import FormRow from '@/components/form/FormRow.vue';
    import {useStore} from 'vuex';
    import {ref, watch} from 'vue';

    const emit = defineEmits<{
        input: [...args: unknown[]];
    }>();

    const props = withDefaults(
        defineProps<{
            value?: 0 | 1;
            message?: string;
            clientTerm?: string;
        }>(),
        {
            value: 1,
            message: '',
            clientTerm: 'Kunde',
        },
    );

    const store = useStore();

    const setNotifyClients = async (value: number): Promise<void> => store.dispatch('module/calendar/setNotifyClients', value);

    const sendMail = ref<number>(0);

    sendMail.value = props.value;

    setNotifyClients(sendMail.value);

    watch(sendMail, () =>
    {
        setNotifyClients(sendMail.value);
    });
</script>